import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * Microsoft OAuth ログイン
 *
 * Microsoftアカウントでのログイン
 */
export class PostMicrosoftLogin implements APIRequest<Monitaro.MicrosoftLoginResponse> {
  response: Monitaro.MicrosoftLoginResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  constructor() {
    this.path = `/oauth/microsoft/login`
  }
}

/**
 * Microsoft OAuth Callback
 *
 * Microsoftアカウントでのログイン
 */
export class PostMicrosoftCallback implements APIRequest<Monitaro.MicrosoftCallbackResponse> {
  response: Monitaro.MicrosoftCallbackResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: any
  constructor(params: any) {
    this.params = params
    this.path = `/oauth/microsoft/callback`
  }
}
